import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "spoiler__wrapper" }
const _hoisted_2 = { class: "spoiler" }
const _hoisted_3 = { class: "spoiler__content" }
const _hoisted_4 = {
  key: 0,
  class: "spoiler__title",
  "data-type": "open"
}
const _hoisted_5 = {
  key: 1,
  class: "spoiler__title",
  "data-type": "close"
}
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "spoiler__header",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setOpen && _ctx.setOpen(...args)))
        }, [
          (!_ctx.isOpen.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, " Выбрать "))
            : (_openBlock(), _createElementBlock("h2", _hoisted_5, "Закрыть"))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: _normalizeClass(_ctx.isOpen.value ? 'spoiler__item spoiler__active' : 'spoiler__item')
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.isOpen.activeElement == item.key ? 'spoiler__active-text' : ''),
              onClick: ($event: any) => (_ctx.setItem(item))
            }, _toDisplayString(item.title), 11, _hoisted_6)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}